import React, { useEffect, useRef, useState } from 'react'
import BudgetPlanningTracker from '../components/BudgetPlanningTracker';
import ProductExpenseTable from '../components/ProductExpenseTable';
import { calculateProduct, getBuisnessStatement, getCombineStats, getProduct } from '../utils/ActionCreator';
import InputMUI from '../utils/InputMUI';
import "../css/classes/budgetPlanningTabs.css";
import SpinnerLoader from '../../../../../../presentationals/Loader/Loader.component';
import { Alert, Snackbar } from '@mui/material';
import '../components/ProductCard/ProductCard.css';
import ProductCard from '../components/ProductCard/ProductCard';
import AddProductSidebar from '../components/addProduct/AddProductSidebar';
import ExpenseStatemement from '../components/ExpenseStatement/ExpenseStatemement';
// import CashFlowStatement from '../components/cashflowTransaction/CashflowStatementTable';
import PlanningTabs from '../components/PlanningTabs/PlanningTabs';
import CashflowStatement from '../components/cashflowTransaction/CashflowStatement';

function BudgetPlanning() {
  const monthlyTotals = [
    '₹ 2,600.00', '₹ 2,600.00', '₹ 2,750.00', '₹ 4,000.00', '₹ 3,100.00', '₹ 3,250.00',
    '₹ 3,100.00', '₹ 4,300.00', '₹ 3,250.00', '₹ 3,100.00', '₹ 3,100.00', '₹ 3,550.00', '₹ 38,700.00'
  ];

  const expenses = [
    {
      category: 'Rent',
      values: Array(12).fill('₹ 1,200.00'),
      total: '₹ 14,400.00'
    },
    {
      category: 'Groceries',
      values: Array(12).fill('₹ 850.00'),
      total: '₹ 10,200.00'
    },
    {
      category: 'Transportation',
      values: Array(12).fill('₹ 300.00'),
      total: '₹ 3,600.00'
    },
    {
      category: 'Insurance',
      values: ['₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00'],
      total: '₹ 600.00'
    },
    {
      category: 'Clothing',
      values: Array(12).fill('₹ 200.00'),
      total: '₹ 2,400.00'
    },
    {
      category: 'Body Care & Medicine',
      values: Array(12).fill('₹ 200.00'),
      total: '₹ 2,400.00'
    },
    {
      category: 'Media',
      values: Array(12).fill('₹ 50.00'),
      total: '₹ 600.00'
    },
    {
      category: 'Fun & Vacation',
      values: ['₹ 300.00', '₹ 300.00', '₹ 300.00', '₹ 1,200.00', '₹ 300.00', '₹ 300.00', '₹ 300.00', '₹ 1,500.00', '₹ 300.00', '₹ 300.00', '₹ 300.00', '₹ 600.00'],
      total: '₹ 6,000.00'
    },
    {
      category: '',
      values: Array(12).fill(''),
      total: '₹ 0.00'
    },
    {
      category: '',
      values: Array(12).fill(''),
      total: '₹ 0.00'
    }
  ];
  const bills = [
    {
      category: 'Water',
      values: Array(12).fill('₹ 1,200.00'),
      total: '₹ 14,400.00'
    },
    {
      category: 'Gas',
      values: Array(12).fill('₹ 850.00'),
      total: '₹ 10,200.00'
    },
    {
      category: 'Electricity',
      values: Array(12).fill('₹ 300.00'),
      total: '₹ 3,600.00'
    },
    {
      category: 'Netflix',
      values: ['₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00', '₹ 0.00', '₹ 0.00', '₹ 150.00'],
      total: '₹ 600.00'
    },
    {
      category: 'HBO Max',
      values: Array(12).fill('₹ 200.00'),
      total: '₹ 2,400.00'
    },
    {
      category: 'Disney Plus',
      values: Array(12).fill('₹ 200.00'),
      total: '₹ 2,400.00'
    },
    {
      category: 'Spotify',
      values: Array(12).fill('₹ 50.00'),
      total: '₹ 600.00'
    },

  ];
  const [monthlyCashFlow, setMonthlyCashFlow] = useState([])
  const [products, setProducts] = useState([])
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [isOpenAddProduct, setIsOpenAddProduct] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("P1");
  const [showCalculatePoupup, setShowCalculatePoupup] = useState(false)
  const [loader, setLoader] = useState(false)
  const [loadingCobineStats, setLoadingCombineStats] = useState(false)
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });
  const [calculateProductPayload, setCaculateProductPayload] = useState({
    loanAprrovedAmt: "",
    countInfuse: "",
    countSchedule: "",

  });

  useEffect(() => {
    fetchProducts();
    fetchMonthlyCashFlow();
  }, [])

  const refreshAll = () => {
    fetchProducts();
    fetchMonthlyCashFlow();

  }
  const resetCalculate = () => {
    setCaculateProductPayload({
      loanAprrovedAmt: "",
      countInfuse: "",
      countSchedule: "",
    })
  }

  const fetchProducts = () => {
    getProduct((callback) => {
      if (callback.message === "success") {

        setProducts(callback.data)
        console.log(callback.data);
        console.log("monthly cash flow", products);
      }
    }, (onError) => { })
  }
  const fetchMonthlyCashFlow = () => {
    getBuisnessStatement((callback) => {
      if (callback.message === "success") {

        setMonthlyCashFlow(callback.data)
        console.log(callback.data);
        console.log("monthly cash flow", monthlyCashFlow);
      }
    }, (onError) => { })
  }

  const selectedProductHandler = (selectedProduct) => {
    setSelectedProduct(selectedProduct);
    setShowCalculatePoupup(true);
  }

  const resetCalculation = () => {
    setSelectedProduct("");
    setShowCalculatePoupup(false);
    resetCalculate();

  }

  const isValidForm = () => {
    if (calculateProductPayload.loanAprrovedAmt === "" || calculateProductPayload.countInfuse === "" || calculateProductPayload.countSchedule === "" || loader) {
      return false;
    } else {
      return true;
    }
  }

  const handleCalculate = () => {
    if (loader) {
      return;
    }
    var payload = { ...calculateProductPayload, productId: selectedProduct };
    // console.log("payload to calculate", payload);
    setLoader(true);
    calculateProduct(payload, (callback) => {
      if (callback.status === 200) {
        setSnackbar({
          open: true,
          message: 'Calculation completed',
          severity: 'success'
        });

        refreshAll();
        setActiveTab(tabs[0]);
        resetCalculation();
      } else {
        setSnackbar({
          open: true,
          message: callback?.data ?? 'Unable to calculate, please try again',
          severity: 'error'
        });
        resetCalculate();
      }

      setLoader(false);
    }, (onErr) => {
      setSnackbar({
        open: true,
        message: 'Unable to calculate, please try again',
        severity: 'error'
      });
      setLoader(false);
    });
  }
  const handleChange = (value, name) => {
    setCaculateProductPayload({ ...calculateProductPayload, [name]: value });
  }
  const handleTabOnAdd = () => {
    if (activeTab !== "Products") {
      setActiveTab("Products");
    }

  }
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };
  const [activeTab, setActiveTab] = useState('Buissness planning');

  const [activeBuisnessTab, setActiveBuisnessTab] = useState('Business');
  const tabs = [
    "Buissness planning",
    "Products",
    "Expense",
    // "CashFlow"
  ];


  useEffect(() => {
    updateIndicator();
  }, [activeTab]);

  const updateIndicator = () => {
    const activeTabElement = tabsRef.current[activeTab];
    if (activeTabElement) {
      const { offsetLeft, offsetWidth } = activeTabElement;
      setIndicatorStyle({
        left: `${offsetLeft}px`,
        width: `${offsetWidth}px`
      });
    }
  };
  const tabsRef = useRef([]);
  const customWidth = {
    width: 'calc(100%/3)'
  }


  const getCombineStatsApi = () => {
    setLoadingCombineStats(true);
    getCombineStats((callback) => {
      refreshAll();
      setLoadingCombineStats(false);
    }, (onErr) => {
      refreshAll();
      setLoadingCombineStats(false);

    });
  }

  useEffect(()=>{
    if(!isOpenAddProduct){
      setEditDetails(null);
      console.log("edit item in budget planning make null")
    }
  },[isOpenAddProduct])



  return (
    <>
      {loadingCobineStats && <SpinnerLoader />}
      <div className="row" style={{ width: "100%" }}>
        <div className="col-xs-12">
          <div className="btn-grp-own-lead-manage-new" role="group" aria-label="onboard-btn" style={{ padding: '10px' }}>
            {tabs.map((tab, idx) => {
              return (

                <button className={activeTab === tabs[idx] ? 'btn-active' : 'btn'} onClick={() => setActiveTab(tab)} style={{ ...customWidth, fontSize: "18px" }}>{tab}</button>

              )
            })
            }

          </div>

        </div>
      </div>


      <AddProductSidebar refreshApi={refreshAll} isOpen={isOpenAddProduct} setIsOpen={setIsOpenAddProduct} handleTabOnAdd={handleTabOnAdd} editItem={editDetails ?? null} />
      {(activeTab === tabs[0]) ?
        <>
          <BudgetPlanningTracker refreshAPi={fetchMonthlyCashFlow} />
          <div style={{ width: "90%", marginLeft: "auto", marginRight: activeBuisnessTab === "Business" ? "100px" : "220px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>

            <PlanningTabs setActiveBuisnessTab={setActiveBuisnessTab} activeBuisnessTab={activeBuisnessTab} />
            {activeBuisnessTab === "Business" &&
              <button
                className={`calculate-btn`}
                onClick={() => getCombineStatsApi()}

              >
                Combine Stats
              </button>
            }
          </div>

          {activeBuisnessTab === "Business" ?
            <>
              {monthlyCashFlow !== null && monthlyCashFlow.map((item) => {
                console.log(item);
                return (
                  <>

                    <div style={{ marginTop: "4rem" }}>

                      <ProductExpenseTable subTitle={(item?.productName ?? "").toString()} data={item?.monthlyData.slice(0, 13)} />
                    </div>
                    {/* <CashFlowStatement /> */}

                  </>
                );

              })}</>
            : <CashflowStatement />}


        </>
        : (activeTab === tabs[1]) ?
          <div style={{ marginTop: "2rem", padding: '4px', width: "100%", display: "flex", justifyContent: "start", alignItems: "center", flexWrap: "wrap", overflowX: "hidden" }}>
            {products && products.map((item, idx) => {
              return (
                <>
                <div className="col-md-4" style={{margin:"2rem 0"}}>
                
                  <ProductCard setIsOpenAddProduct={setIsOpenAddProduct} item={item} handleCalculate={selectedProductHandler} setEditDetails={setEditDetails} />
                </div>
                {/* <div className="col-md-4" style={{margin:"2rem 0"}}>
                  <ProductCard item={item} handleCalculate={selectedProductHandler} />
                </div> */}
              </>
              )
            })}
          </div>
          :  <ExpenseStatemement />
      }



      {showCalculatePoupup &&

        <div className="">
          <div className="background-blur"></div>
          <div className="popup-main container-fluid w-100" style={{ backgroundColor: "transparent", boxShadow: "none", display: "flex", alignItems: "end", justifyContent: "center", maxWidth: "700px", zIndex: 1000, top: "25%" }}>
            <div style={{ backgroundColor: "transparent", boxShadow: "none", display: "block", alignItems: "center", width: "100%" }}
            >
              {!loader &&
                <button style={{ position: 'absolute', right: '25px' }}>

                  <i onClick={() => { resetCalculation(); }} style={{ float: "right", marginTop: '-35px', marginRight: '-25px', fontSize: '30px', color: 'red' }} className="fa fa-times-circle"></i>
                </button>
              }

              <div style={{
                padding: "5px 2rem 2rem 2rem",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
              }}>
                <h3 style={{ fontWeight: "600", color: "black" }}>Calculate</h3>


                <div style={{ marginTop: "1rem" }}>

                  <div style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '0px 20px',
                    borderRadius: '16px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease'
                  }}>
                    <InputMUI
                      label="Loan Aprroved Amount"
                      variant="outlined"
                      name="loanAprrovedAmt"
                      id="loanAprrovedAmt"
                      type="number"
                      size="small"
                      required={true}
                      onChange={(value) => handleChange(value, "loanAprrovedAmt")}
                      value={calculateProductPayload.loanAprrovedAmt}

                    />
                  </div>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '10px 20px',
                    borderRadius: '16px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease'
                  }}>
                    <InputMUI
                      label="Count Infuse"
                      variant="outlined"
                      name="countInfuse"
                      id="countInfuse"
                      type="number"
                      size="small"
                      required={true}
                      onChange={(value) => handleChange(value, "countInfuse")}
                      value={calculateProductPayload.countInfuse}

                    />
                  </div>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '10px 20px',
                    borderRadius: '16px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease'
                  }}>
                    <InputMUI
                      label="Count Schedule"
                      variant="outlined"
                      name="countSchedule"
                      id="countSchedule"
                      type="number"
                      size="small"
                      required={true}
                      onChange={(value) => handleChange(value, "countSchedule")}
                      value={calculateProductPayload.countSchedule}

                    />
                  </div>

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '22px'
                  }}>
                    <button
                      onClick={handleCalculate}
                      disabled={!isValidForm()}
                      style={{
                        background:
                          isValidForm()
                            ?
                            'linear-gradient(145deg, #00807a, #004d49)'
                            : 'linear-gradient(145deg, #cccccc, #999999)',
                        border: 'none',
                        borderRadius: '50px',
                        padding: '16px 48px',
                        color: '#ffffff',
                        fontSize: '16px',
                        fontWeight: '600',
                        // cursor: 'pointer',
                        cursor: isValidForm() ? 'pointer' : 'not-allowed',
                        transition: 'all 0.3s ease',
                        // boxShadow: isFormValid() 
                        //   ? '0 8px 25px #008078' 
                        //   : '0 4px 12px rgba(0,0,0,0.2)',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        minWidth: '200px',
                        position: 'relative',
                        overflow: 'hidden',
                        // opacity: 1 
                        opacity: isValidForm() ? 1 : 0.6
                      }}
                      onMouseEnter={(e) => {
                        // if (isFormValid()) {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 2px 10px #008078';
                        // }
                      }}
                      onMouseLeave={(e) => {
                        // if (isFormValid()) {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 0px 0px #008078';
                        // }
                      }}
                    >{!loader ? "Calculate" : "Calculating..."}

                    </button>
                  </div>

                  {loader && <SpinnerLoader />}


                </div>
              </div>
            </div>
          </div>
        </div>

      }

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


      {/* <CommonBudgetTable monthlyTotals={monthlyTotals} title={"Expenses"} subTitle={"Expenses Budget"} data={expenses} />
      <CommonBudgetTable monthlyTotals={monthlyTotals} title={"Bills"} subTitle={"Bills Budget"} data={bills}  /> 
      */}

    </>
  )
}

export default BudgetPlanning;